// extracted by mini-css-extract-plugin
export default {"post":"Post_post__mbmXq","date":"Post_date__mtUYo","category":"Post_category__fP5Cm","link":"Post_link__o9fRh","label":"Post_label__tp-4e","title":"Post_title__2cG86"};